import React from 'react';
import { Link } from 'react-router-dom';

const NavigationBar = (props) => {
  const { user, location } = props;
  const { pathname } = location;
  return (
    <>
      <nav className={"navbar navbar-expand-lg navbar-light bg-light"}>
        <Link className={"navbar-brand"} to={"/everest"}>Home</Link>
        <button className={"navbar-toggler"} type={"button"} data-toggle={"collapse"} data-target={"#navbarNav"} aria-controls={"navbarNav"} aria-expanded={"false"} aria-label={"Toggle navigation"}>
          <span className={"navbar-toggler-icon"}></span>
        </button>
        <div className={"collapse navbar-collapse"} id="navbarNav">
          <ul className={"navbar-nav mr-auto"} />
          {user && !!user.userId && (<>
            <ul className={"navbar-nav"}>
              <li className={"nav-item"}>
                <Link className={`nav-link ${pathname === "" ? "active" : ""}`} to={"/everest/login"}>Login</Link>
              </li>
              <li className={"nav-item"}>
                <Link className={`nav-link ${pathname === "" ? "active" : ""}`} to={"/everest/join"}>Join</Link>
              </li>
            </ul>
          </>)}
          {user && user.userId && (<>
            <ul className={"navbar-nav"}>
              <NavItemLink to={"/everest/me"} name={"MyAccount"} location={location} />
              <li className={"nav-item"}>
                <Link className={`nav-link ${pathname === "" ? "active" : ""}`} to={"/everest/me"}>MyAccount</Link>
              </li>
              <li className={"nav-item"}>
                <a className={`nav-link ${pathname === "" ? "active" : ""}`} href={"/oauth2/everest/logout"}>Logout</a>
              </li>
            </ul>
          </>)}
        </div>
      </nav>
    </>
  );
};

const NavItemLink = (props) => {
  const { to, name, location } = props;
  const getActiveCls = () => (location.pathname === to) ? "active" : "";
  return (
    <li className={"nav-item"}>
      <Link className={`nav-link ${getActiveCls()}`} to={to}>{name}</Link>
    </li>
  );
};

export { NavigationBar };
